<template>
    <v-container fluid class="pavo-page">
        <div class="d-flex align-center mb-5 ga-4">
            <h1 class="text-h5 font-weight-medium">Dashboard</h1>
            <v-chip variant="outlined" class="pavo-mono">{{ todayLabel }}</v-chip>
        </div>
        <v-alert v-if="error" type="error" variant="tonal">Could not load the dashboard.</v-alert>
        <v-progress-linear v-else-if="isPending" indeterminate color="primary" />
        <template v-else-if="data">
            <DashboardStatTiles :dashboard="data" class="mb-4" />
            <v-row>
                <v-col cols="12" lg="7">
                    <TodaysFunctionsTable :functions="data.todaysFunctions" />
                </v-col>
                <v-col cols="12" lg="5">
                    <FunctionHeatCalendars
                        :from="data.functionCountsFrom"
                        :counts="data.functionCounts"
                    />
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script setup lang="ts">
import DashboardStatTiles from "@c/dashboard/DashboardStatTiles.vue";
import TodaysFunctionsTable from "@c/dashboard/TodaysFunctionsTable.vue";
import FunctionHeatCalendars from "@c/dashboard/FunctionHeatCalendars.vue";
import { useDashboardQuery } from "@/queries/dashboard";

const { data, error, isPending } = useDashboardQuery();

const todayLabel = new Date().toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
});
</script>

<style lang="scss">
.pavo-page {
    max-width: 1280px;
}
</style>
